import initLoadMore from './components/load-more';

const loadMoreDiv = document.querySelector('.js-load-more-target');
const loadMoreBtn = document.querySelector('.js-load-more-button');

if (loadMoreDiv && loadMoreBtn) {
    initLoadMore(loadMoreDiv, loadMoreBtn);
}
